import Dining from './Dining';

export default Dining;